{
  "nl": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Verander logo (png vereist)",
        "changeThemeColor": "Kies een nieuw themakleur"
      },
      "errors": {
        "themeColorInvalid": "Vul zes tekens in, 0-9 of A-F. Bijvoorbeeld 096553."
      },
      "labels": {
        "customerThemeColor": "Themakleur klant",
        "customerThemeColorExlainer": "Dit kleur wordt gebruikt voor het klantenportaal. Impersoneer een klant om dit in actie te zien.",
        "logo": "Logo"
      },
      "paused": {
        "description": "Je account bij {client} bestaat nog, maar je toegang staat nu uit, dus het platform blijft dicht. Een eigenaar van je organisatie kan je toegang weer aanzetten.",
        "noAccess": "Geen toegang",
        "open": "Openen",
        "title": "Je toegang is gepauzeerd",
        "yourOrganizations": "Jouw organisaties"
      },
      "picture_logo_format": {
        "round": "Rond logo",
        "square": "Vierkant logo"
      }
    }
  }
}
